module.exports = __webpack_public_path__ + "media/react/assets/images/background-image-50daa2460a3e0bfaf3df3e388ff9db3e.jpg";